var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthDiaryViewHealthEntries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff4a4a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_132",
    "data-name": "Layer 132"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.37,321.57h91l46.85-108.49c4.15-9.63,14.05-16,23.3-15.49,9.95.24,18.85,6.79,22.58,16.61L258.89,332,287,278.79a24.9,24.9,0,0,1,21.43-13.58,24,24,0,0,1,21.23,12l29.67-148.65c2.5-12.52,12.38-21.6,25.1-21.06,12,.32,22.13,9.71,24,22.39l28.8,191.73H565.63a287.45,287.45,0,0,0,26.15-70.63c8.48-37.78,6.15-62,5.15-68.82-9.2-104.36-80-180-168.68-180-51.11,0-99.73,25.48-131.66,68.56C265.21,27,218.71,2.1,167.75,2.1,79.1,2.1,8.27,77.74-1,182.12c-1,6.84-3.3,31,5.15,68.82a288.75,288.75,0,0,0,26.18,70.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M415.9,374.81c-12.27,0-22.75-9.5-24.67-22.41l-11-72.9-14.9,74.65c-2.13,10.68-10.21,18.9-20.31,20.71s-20.3-3.14-25.55-12.48l-10-17.65L277,406.3a24.74,24.74,0,0,1-21.8,13.58c-.53,0-1.05,0-1.58-.05-9.6-.64-18-7.08-21.6-16.56l-42.58-112-29.35,68c-4.1,9.42-13,15.49-22.73,15.49h-71a303.15,303.15,0,0,0,21.46,23L298,596.78l210.26-199a299.9,299.9,0,0,0,21.4-22.92Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthDiaryViewHealthEntries);
export default __webpack_public_path__ + "static/media/health_diary_view_health_entries.1ca11389397ad6115c30961265426c06.svg";
export { ForwardRef as ReactComponent };